import styled from 'styled-components'
import { padding, PaddingProps } from 'styled-system'
import themeGet from '@styled-system/theme-get'

import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

import { LANDING_CONTENT_WIDTH_PX } from 'Constants/Landing'

const shouldForwardProp = (prop: string) =>
  !DIV_SHOULD_FORWARD_PROP.includes(prop)

export const Container = styled.div.withConfig({
  shouldForwardProp,
})<PaddingProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: ${LANDING_CONTENT_WIDTH_PX};
  background-color: ${themeGet('colors.background.screenAlt')};
  gap: ${themeGet('space.6')}px;

  @media screen and (min-width: ${themeGet('breakpoints.2')}) {
    gap: ${themeGet('space.11')}px;
  }

  ${padding}
`
